import React from 'react';
import CountUp from 'react-countup';
import { GlowingEffect } from './border-effect/GlowingEffect';

const StatCard = ({ value, suffix, label, inView, cardRef }) => {
  return (
    <div
      ref={cardRef}
      className="relative group rounded-lg bg-[#242424] lg:py-3 lg:px-6 p-2 flex flex-col justify-center items-start transition-transform duration-300"
    >
      <GlowingEffect
        blur={0}
        borderWidth={2}
        spread={80}
        glow={true}
        disabled={false}
        proximity={64}
        inactiveZone={0.01}
        className="opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      />
      <p className="relative z-10 text-[#00E599] text-[20px] md:text-[54px] leading-none md:leading-[76px] font-dmsans font-medium lg:font-bold">
        {inView ? (
          <CountUp start={0} end={value} duration={2} suffix={suffix} />
        ) : (
          `0${suffix}`
        )}
      </p>
      <p className="relative z-10 text-[11px] md:text-heading-6 font-dmsans lg:mt-0 mt-1">{label}</p>
    </div>
  );
};

export default StatCard;
